import { render, staticRenderFns } from "./QRCodeDisplay.vue?vue&type=template&id=06ce5b17&scoped=true"
import script from "./QRCodeDisplay.vue?vue&type=script&lang=js"
export * from "./QRCodeDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ce5b17",
  null
  
)

export default component.exports